import { FormFields, FormValidationSchema } from '@/common/interfaces';

export enum PageFormInputs {
  Title = 'title',
  Body = 'body',
  UsageFor = 'usageFor',
  PublishedAt = 'publishedAt',
  StructureNodeId = 'structureNodeId',
  LayoutId = 'layoutId',
}

export type PageFormFields = FormFields<typeof PageFormInputs>;

export type PageFormValidationSchema = FormValidationSchema<PageFormFields>;

export type PagesBulkPublishAction = 'publish' | 'unpublish';

export type PagesBulkPublishScope = 'all' | 'selected';

export enum PagesBulkPublishFormInputs {
  Scope = 'scope',
  UsageForVariants = 'usageForVariants',
  PageIds = 'pageIds',
  PublishedAt = 'publishedAt',
};

export type PagesBulkPublishFormFields = FormFields<typeof PagesBulkPublishFormInputs>;

export type PagesBulkPublishFormValidationSchema = FormValidationSchema<PagesBulkPublishFormFields>;

export enum PagesViewMode {
  Pages = 'pages',
  Structure = 'structure',
}

export type PageUsageForType = NonNullable<{ type: 'default' } | PageUsageForVisitorBotType>;

export enum PageUsageForKeys {
  Location = 'location',
  Bot = 'bot',
}

export enum PageUsageForBots {
  Google = 'google',
}

export type PageUsageForVisitorBotType = {
  [PageUsageForKeys.Bot]: PageUsageForBots;
};

export enum PageSearchAndReplaceFormInputs {
  SearchFor = 'searchFor',
  ReplaceWith = 'replaceWith',
  MatchCase = 'matchCase',
  WholeWord = 'wholeWord',
  UseRegex = 'useRegex',
}

export type PageSearchAndReplaceFormFields = FormFields<typeof PageSearchAndReplaceFormInputs>;

export type PageSearchAndReplaceAutocompleteQuery = Pick<
  PageSearchAndReplaceFormFields,
  'searchFor' | 'matchCase' | 'wholeWord' | 'useRegex'
>;

export type PageSearchAndReplaceFormValidationSchema = FormValidationSchema<PageSearchAndReplaceFormFields>;

export type SearchAndReplaceAutocompleteResponse = {
  totalWordsCount: number;
  pagesCount: number;
};

export interface ReplaceDto {
  search: string;
  replaceWith: string;
  useRegex?: boolean;
  matchCase?: boolean;
  wholeWord?: boolean;
}

export interface ReplacementVersion {
  version: string;
  createdAt: string;
  expiresAt: string;
  replacementInfo: ReplaceDto;
}

export interface SearchAndReplaceRollbackResponse {
  restoredItems: number;
}
